import axios from '../Backend';

export const updateTempMsg = async (req) => {
    try {
        // const tempToken = localStorage.getItem('token')
        // if (tempToken !== undefined && tempToken !== null) {
        await axios.put('/agentServices/updateTempMsg', req);
        // }
    } catch (e) {
        console.log('dispatch updateTempMsg fail')
        console.log(JSON.stringify(e.response.data))
    }
}

export const addTempMsg = async (req) => {
    try {
        // const tempToken = localStorage.getItem('token')
        // if (tempToken !== undefined && tempToken !== null) {
        await axios.post('/agentServices/addTempMsg', req);
        // }
    } catch (e) {
        console.log('dispatch updateTempMsg fail')
        console.log(JSON.stringify(e.response.data))
    }
}

export const deleteTempMsg = async (_id) => {
    try {
        // const tempToken = localStorage.getItem('token')
        // if (tempToken !== undefined && tempToken !== null) {
        await axios.delete('/agentServices/deleteTempMsg?_id=' + _id);
        // }
    } catch (e) {
        console.log('dispatch updateTempMsg fail')
        console.log(JSON.stringify(e.response.data))
    }
}
